import { getToConnect, connectedDriver, getCarrierDriverAvailable } from "@/api/eldv2";
import cloneDeep from "lodash/cloneDeep";
import Vue from "vue";
import { systemInfo } from '@/shared-services'


export default {
  namespaced: true,
  state: {
    connectedLoading: false,
    toConnectLoading: false,
    prevConnectedDate: null,
    prevToConnectDate: null,
    connectedList: [],
    sourceList: [],
    filters: {
      search: "",
      source: "",
      carrierCheck: ""
    },
    connectedColumns: [
      {
        fieldName: "driverName",
        caption: "Driver Name",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "120px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "eldDriverName",
        caption: "Driver Name(ELD)",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "120px",
        params: {
          noClickCell: true,
        },
      },
      {
        fieldName: "location",
        caption: "Location",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "110px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "breakTime",
        caption: "Break",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "65px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "driveTime",
        caption: "Drive",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "65px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "shiftTime",
        caption: "Shift",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "65px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "cycleTime",
        caption: "Cycle",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "65px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      
      {
        fieldName: "cycleToday",
        caption: "Avialable Today",
        fixed: "",
        slotHeader: true,
        textAlignment: "left",
        allowSort: false,
        minWidth: "92px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "cycleTomorrow",
        caption: "Avialable Tomorrow",
        fixed: "",
        slotHeader: true,
        textAlignment: "left",
        allowSort: false,
        minWidth: "92px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "cycleRule",
        caption: "Cycle Rule",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "134px",
        params: {
          noClickCell: true,
        },
        // type: "slot",
      },
      
      
      
      
      
      {
        fieldName: "email",
        caption: "Email",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "120px",
        params: {
          noClickCell: true,
        },
        formatter: (row) => {
          return row.email || '--'
        }
      },
      {

        fieldName:  "eldDriverEmail",
        caption: "ELD Email",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "120px",
        params: {
          noClickCell: true,
        },
        formatter: (row) => {
          
          return  row.eldDriverEmail || '--'
        }
      },
      {
        fieldName: "contactNumber", // ???
        caption: "Contact Number",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "113px",
        params: {
          noClickCell: true,
        },
        formatter: (row) => {
          const str = String(row.contactNumber).replace(/\D/g, '')
          if (!str) return '--';
          return '(' + str.slice(0, 3) + ') ' + str.slice(3, 6) + '-' + str.slice(6);
        }
      },
      {
        fieldName: "eldAccount",
        caption: "ELD Type",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "115px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "action",
        caption: "Action",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "135px",
        type: "slot",
      }
    ],
    connectEldColumns: [
      {
        fieldName: "driverName",
        caption: "Driver Name",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "140px",
        type: "slot",
        params: {
          noClickCell: true,
        },
      },
      {
        fieldName: "driverEmail",
        caption: "Email",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "187px",
        formatter: (row) => {
          return row.driverEmail || '--'
        },
        params: {
          noClickCell: true,
        },
      },
      {
        fieldName: "driverPhone",
        caption: "Contact Number",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "178px",
        formatter: (row) => {
          const str = String(row.driverPhone).replace(/\D/g, '')
          if (!str) return '--';
          return '(' + str.slice(0, 3) + ') ' + str.slice(3, 6) + '-' + str.slice(6);
        },
        params: {
          noClickCell: true,
        },
      },
      {
        fieldName: "eldDriverName",
        caption: "Driver Name",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "140px",
        type: "slot",
        params: {
          noClickCell: true,
        },
      },
      {
        fieldName: "eldEmail",
        caption: "ELD Email",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "187px",
        formatter: (row) => {
          return row.eldEmail || '--'
        },
        params: {
          noClickCell: true,
        },
      },
      {
        fieldName: "eldPhone",
        caption: "Contact Number",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "163px",
        formatter: (row) => {
          const str = String(row.eldPhone).replace(/\D/g, '')
          if (!str) return '--';
          return '(' + str.slice(0, 3) + ') ' + str.slice(3, 6) + '-' + str.slice(6);
        },
        params: {
          noClickCell: true,
        },
      },
      {
        fieldName: "eldAccount",
        caption: "ELD Type",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "115px",
        type: "slot",
        params: {
          noClickCell: true,
        },
      }
    ],
    driverList: [],
    eldList: [],
    carrierDriverAvailable: 0
  },
  mutations: {
    SET_CONNECTEDLIST(state, list = []) {
      state.connectedList = list;
    },
    SET_CONNECTEDLIST_WS(state, list = []) {
      state.connectedList && state.connectedList.forEach(item => {
        let obj = list.find(it => it.driverId === item.fleetId)
        if (obj) {
          item.location = obj.lastKnownLocation
        } 
      })
    },
    SET_CARRIERDRIVERAVAILABLE(state, data = 0) {
      state.carrierDriverAvailable = data;
    },
    SET_FILTERS(state, payload) {
      state.filters = payload;
    },
    SET_TOCONNECTLOADING(state, loading) {
      state.toConnectLoading = loading;
    },
    SET_CONNECTEDLOADING(state, loading) {
      state.connectedLoading = loading;
    },
    SET_DRIVERLIST(state, list = []) {
      state.driverList = list;
    },
    SET_ELDLIST(state, list = []) {
      state.eldList = list;
    },
    SET_PREVCONNECTEDDATE(state, date = null) {
      state.prevConnectedDate = date;
    },
    SET_PREVTOCONNECTDATE(state, date = null) {
      state.prevToConnectDate = date;
    },
    SET_SOURCELIST(state, list = []) {
      state.sourceList = list;
    }
  },
  actions: {
    setDriverList({commit }, list) {
      console.log(list, 'next11')
      commit('SET_DRIVERLIST', list || [])
    },
    updateEldDriverListByWs({commit}, list) {
      commit('SET_CONNECTEDLIST_WS', list)
    },
    getCarrierAvailable({ commit, rootGetters } ) {
      const fleetCompanyId = rootGetters['eld2/carrierCheck']
      if (fleetCompanyId) {
        return getCarrierDriverAvailable(fleetCompanyId).then(res => {
          commit('SET_CARRIERDRIVERAVAILABLE', res?.res?.data?.data?.available)
        })
      }
    },
    updateConnectLoading({ commit }, update) {
      commit('SET_CONNECTEDLOADING', update);
    },
    async updateEldDriverData({ dispatch }, update = false) {
      await dispatch('getConnectedList', update);
      await dispatch('getToConnectList', update);
    },
    async getConnectedList({ state, commit, rootGetters, dispatch }, update = false) {
      if (!update && state.prevConnectedDate && Date.now() - state.prevConnectedDate < 60000) return;
      const fleetCompanyId = rootGetters['eld2/carrierCheck']
      if (!systemInfo.isCommand && !fleetCompanyId) {
        dispatch('updateConnectLoading', false)
        return
      }
      commit('SET_CONNECTEDLOADING', true);
      commit('SET_PREVCONNECTEDDATE', Date.now());
      await connectedDriver({
        companyId: fleetCompanyId,
        blurry: state.filters.search,
        source: state.filters.source,
        page: 0,
        size: 10000,
      }).then(({ res }) => {
        const { code, message, data } = res.data;
        if (code !== 200) {
          Vue.prototype.$message.error(message);
          commit('SET_PREVCONNECTEDDATE');
          return;
        }
        const flts = (data.allSource || []).map(item => {
          return {
            label: item.showValue,
            value: item.value,
          }
        });
        commit('SET_SOURCELIST', flts);
        commit('SET_CONNECTEDLIST', data.content);
      }).catch(({ error }) => {
        Vue.prototype.$message.error(error.message);
        commit('SET_PREVCONNECTEDDATE');
      }).finally(() => {
        commit('SET_CONNECTEDLOADING', false);
      });
    },
    async getToConnectList({ state, commit, rootGetters, dispatch }, update = false) {
      if (!update && state.prevToConnectDate && Date.now() - state.prevToConnectDate < 60000) return;
      const fleetCompanyId = rootGetters['eld2/carrierCheck']
      if (!systemInfo.isCommand && !fleetCompanyId) {
        return
      }
      dispatch('getCarrierAvailable')
      commit('SET_TOCONNECTLOADING', true);
      commit('SET_PREVTOCONNECTDATE', Date.now());
      await getToConnect(fleetCompanyId).then(({ res }) => {
        const { code, message, data } = res.data;
        if (code !== 200) {
          Vue.prototype.$message.error(message);
          commit('SET_PREVTOCONNECTDATE');
          return;
        }
        const { eldToConnectDriverVOList } = data;
        // commit('SET_DRIVERLIST', fleetToConnectDriverVOList);
        commit('SET_ELDLIST', eldToConnectDriverVOList.map(item => {
          return {
            ...item,
            checCheckboxkRenderObj: {
              checCheckboxkRender: true,
              checCheckboxkRenderFileName: 'email',
            },
          }
        }));
      }).catch(({ error }) => {
        Vue.prototype.$message.error(error.message);
        commit('SET_PREVTOCONNECTDATE');
      }).finally(() => {
        commit('SET_TOCONNECTLOADING', false);
      });
    },
  },
  getters: {
    mergeDriverEld(state) {
      const driverList = cloneDeep(state.driverList),
        eldList = cloneDeep(state.eldList);
      if (!driverList.length && !eldList.length) return { invited: [], uninvited: [] };
      const mergeDriverArr = [],
        uninvitedEld = [];
      for (let i = 0; i < driverList.length; i++) {
        const currentDriver = driverList[i];
        const flts = eldList.filter(item => currentDriver.email && item.email === currentDriver.email);
        if (!flts.length) {
          const phoneFlts = eldList.filter(item => currentDriver.phone && item.phone === currentDriver.phone);
          if (phoneFlts.length) {
            const firstMatch = phoneFlts[0];
            mergeDriverArr.unshift({
              fleetId: currentDriver.id,
              driverName: currentDriver.driverName,
              driverEmail: currentDriver.email,
              driverPhone: currentDriver.phone,
              eldDriverName: firstMatch.driverName,
              eldEmail: firstMatch.email,
              eldPhone: firstMatch.phone,
              eldAccount: firstMatch.eldAccount,
              eldId: firstMatch.id,
              source: firstMatch.source,
              id: currentDriver.id + '' + firstMatch.id,
            });
          } else {
            mergeDriverArr.push({
              fleetId: currentDriver.id,
              driverName: currentDriver.driverName,
              driverEmail: currentDriver.email,
              driverPhone: currentDriver.phone,
              eldDriverName: '',
              eldEmail: '',
              eldPhone: '',
              eldAccount: '',
              eldId: '',
              source: '',
              id: currentDriver.id + 'fleet',
            });
          }
        } else {
          let currentEld = {};
          if (flts.length > 1) {
            // 匹配phone相同
            const phoneFlts = flts.filter(item => String(item.phone).replace(/\D/g, '') === String(currentDriver.phone).replace(/\D/g, ''));
            if (phoneFlts.length) {
              currentEld = phoneFlts[0];
            } else {
              currentEld = flts[0];
            }
          } else {
            currentEld = flts[0];
          }
          mergeDriverArr.unshift({
            fleetId: currentDriver.id,
            driverName: currentDriver.driverName,
            driverEmail: currentDriver.email,
            driverPhone: currentDriver.phone,
            eldDriverName: currentEld.driverName,
            eldEmail: currentEld.email,
            eldPhone: currentEld.phone,
            eldAccount: currentEld.eldAccount,
            eldId: currentEld.id,
            source: currentEld.source,
            id: currentDriver.id + '' + currentEld.id,
          });
        }
      }
      eldList.forEach(eldItem => {
        if (!mergeDriverArr.find(item => item.eldId === eldItem.id)) {
          uninvitedEld.push({
            fleetId: '',
            driverName: '',
            driverEmail: '',
            driverPhone: '',
            eldDriverName: eldItem.driverName,
            eldEmail: eldItem.email,
            eldPhone: eldItem.phone,
            eldAccount: eldItem.eldAccount,
            eldId: eldItem.id,
            source: eldItem.source,
            id: eldItem.id + 'eld',
          });
        }
      });
      return {
        invited: mergeDriverArr,
        uninvited: uninvitedEld
      }
    }
  }
}
